import { SocialType } from '@interface/gatsby';

export const ARTSTATION: SocialType = 'artstation';
export const FAB: SocialType = 'fab';
export const YOUTUBE: SocialType = 'youtube';
export const INSTAGRAM: SocialType = 'instagram';
export const X: SocialType = 'x';
export const FACEBOOK: SocialType = 'facebook';
